import React, { useState, useEffect, useRef } from "react";
import Page from "../../finwell/pages/Page";
import { useDispatch, useSelector } from "react-redux";
import {
  postWorkshop,
  postWorkshopClear,
} from "../../redux/groupWorkshop/actions";
import _ from "lodash";
import "./GroupWorkShop.scss";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import GroupWorkshopForm from "../../components/GroupWorkshop/GroupWorkshopForm";
import { routeList } from "../../utils/routeList";

const GroupWorkshop = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const postDataRef = useRef({});

  const Weekdays = [
    { day: "Monday", id: "1" },
    { day: "Tuesday", id: "2" },
    { day: "Wednesday", id: "3" },
    { day: "Thursday", id: "4" },
    { day: "Friday", id: "5" },
    { day: "Saturday", id: "6" },
    { day: "Sunday", id: "7" },
  ];

  const languageOptions = [
    {
      value: "english",
      label: "English",
      id: "1",
    },
    {
      value: "french",
      label: "French",
      id: "2",
    },
  ];
  
  const groupWorkshopStore = useSelector((state) => state.groupworkshop);

  const [isMinuteSelected, setIsMinuteSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("flexRadioDefault1");
  const [chips, setChips] = useState([]);
  const [participantChips, setParticipantChips] = useState([]);
  const [selectedTrainerId, setSelectedTrainerId] = useState([]);
  const [selectedParticipantId, setSelectedParticipantId] = useState([]);
  
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [trainerValidation, setTrainerValidation] = useState("");
  const [memberValidation, setMemberValidation] = useState("");
  const [workshopValidation, setWorkshopValidation] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const [addDaysCount,setAddDaysCount] = useState("1");
  const [isDraft, setIsDraft] = useState(false);



  useEffect(() => {   
    console.log("workshopSS",groupWorkshopStore) 
    if (!_.isEmpty(groupWorkshopStore.groupWorkshopSubmit)) {
      const submitRes = groupWorkshopStore.groupWorkshopSubmit;
      if (submitRes?.status === "success") {        
        setIsLoading(false);
        setShowModalMsg("Group workshop successfully created");        
        setConfirmModal(true);
        setTimeout(() => {
          navigate(routeList.GROUP_WORKSHOP_LISTING)
        }, 2000);
      } else {
        console.log("error ")
        setIsLoading(false);        
        setError("Something went wrong");
        setShowLimitPopup(true);
      }
      dispatch(postWorkshopClear({}));        
    }
  }, [groupWorkshopStore]);


  // const handleSubmitForm = () => {
  //   const dataSubmit = postDataRef.current;
  //   if (!_.isEmpty(dataSubmit.urls)) {
  //     alert(JSON.stringify(dataSubmit.urls))
  //     if (_.isEmpty(dataSubmit.workshop_prerequisites)) {
  //       dataSubmit.workshop_prerequisites = []
  //     }
  //     for (let u of dataSubmit.urls) {
  //       dataSubmit.workshop_prerequisites.push({
  //         url: u,
  //         name: u,
  //         type: "url",
  //       })
  //     } 
  //   }
  //   console.log("object90",dataSubmit.meeting_url, dataSubmit);
  //   return;

  //   if (!trainerValidation && _.isEmpty(chips)) {
  //     setTrainerValidation("Trainer Name is Required");
  //   }
  //   if (!memberValidation && _.isEmpty(participantChips)) {
  //     setMemberValidation("End user Name is Required");
  //   }
  //   if (!workshopValidation && !dataSubmit?.workshop_name) {
  //     setWorkshopValidation("Workshop Name is Required");
  //   }
    
  //   if (!dataSubmit?.workshop_name || selectedTrainerId.length === 0) {
  //     window.scroll({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }
  //   if (      
  //     dataSubmit.session_title.every((title) => !title.trim()) ||      
  //     dataSubmit.start_date.every((title) => title === "Invalid date") ||
  //     dataSubmit.event_enddate.every((title) => title === "Invalid date") ||      
  //     dataSubmit.start_time.every((time) => !time.trim()) ||
  //     dataSubmit.end_time.every((time) => !time.trim()) ||          
  //     dataSubmit.meeting_url.every((url) => !url.trim())       
  //   ) {
  //     window.scroll({
  //       top: 622,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

    

  //   const startDate = new Date(
  //     dataSubmit.start_date + " " + dataSubmit.start_time
  //   );
  //   const endDate = new Date(
  //     dataSubmit.event_enddate + " " + dataSubmit.end_time
  //   );

  //   if (endDate <= startDate) {
  //     window.scroll({
  //       top: 722,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

  //   if (dataSubmit?.recurring_type_0 === "weekly" && !dataSubmit?.recur_weekly_on) {
  //     console.log("sooraj")
  //     window.scroll({
  //       top: 1170,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

    

  //   // if((dataSubmit?.recurring_type_0 === "daily" || dataSubmit?.recurring_type_0 === "weekly" || dataSubmit?.recurring_type_0 === "monthly") && (!dataSubmit?.noofoccurances)){
  //   //   console.log("sooraj2")
  //   //   window.scroll({
  //   //     top: 1000,
  //   //     behavior: "smooth",
  //   //   });
  //   //   return;
  //   // }
  //   if((dataSubmit?.recurring_type_0 === "monthly") && (dataSubmit?.monthly_option === "1" ) && (!dataSubmit?.monthly_value)){
  //     console.log("sooraj3")
  //     window.scroll({
  //       top: 1000,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

  //   if( dataSubmit?.recurring_type_0 === "monthly" &&
  //     dataSubmit?.monthly_option === "2" &&
  //     (
  //       dataSubmit?.monthly_option_number === "" || 
  //       dataSubmit?.monthly_option_week === "" || 
  //       dataSubmit?.month_number === ""
  //     )
  //   )  {
  //     console.log("sooraj3")
  //     window.scroll({
  //       top: 1000,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

  //   // if((dataSubmit?.recurring_type_0 === "daily" || dataSubmit?.recurring_type_0 === "weekly" || dataSubmit?.recurring_type_0 === "monthly") && (!dataSubmit?.noofoccurances)){
  //   //   console.log("sooraj2")
  //   //   window.scroll({
  //   //     top: 1250,
  //   //     behavior: "smooth",
  //   //   });
  //   //   return;
  //   // }
    

  //   if (!dataSubmit?.language_id || !dataSubmit?.timezone ||  selectedParticipantId.length === 0) {
  //     console.log("objectxx",addDaysCount)
  //     window.scroll({
  //       top: selectedOption === "flexRadioDefault2" 
  //       ? 1350 
  //       : 1100 + (addDaysCount === "2" ? 590 : addDaysCount === "3" ? 1050 : 0),
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

  //   if (!dataSubmit?.description) {
  //     window.scroll({
  //       top: selectedOption === "flexRadioDefault2" 
  //       ? 1700 
  //       : 1600 + (addDaysCount === "2" ? 530 : addDaysCount === "3" ? 1050 : 0),

  //       // top: selectedOption === "flexRadioDefault2" ? 1700 : 1600,
  //       behavior: "smooth",
  //     });
  //     return;
  //   }

  //   if (isChecked) {
  //     if (
  //       !dataSubmit?.kickoff_start_date ||
  //       !dataSubmit?.kickoff_end_date ||
  //       !dataSubmit?.kickoff_start_time ||
  //       !dataSubmit?.kickoff_end_time ||
  //       !dataSubmit?.kickoff_url
  //     ) {
  //       window.scroll({
  //         top: selectedOption === "flexRadioDefault2" 
  //       ? 1900 
  //       : 1880 + (addDaysCount === "2" ? 530 : addDaysCount === "3" ? 1050 : 0),
  //         // top: selectedOption === "flexRadioDefault2" ? 1900 : 1750,
  //         behavior: "smooth",
  //       });
  //       return;
  //     }

  //     // if (kickoffLatestStartTime && latestSessionStartTime) {
  //     //   if (kickoffLatestStartTime > latestSessionStartTime) {          
  //     //     window.scroll({
  //     //       // top: selectedOption === "flexRadioDefault2" ? 1900 : 1750,
  //     //       top: selectedOption === "flexRadioDefault2" 
  //     //   ? 1900 
  //     //   : 1750 + (addDaysCount === "2" ? 530 : addDaysCount === "3" ? 1050 : 0),
  //     //       behavior: "smooth",
  //     //     });
  //     //     return;
  //     //   }
  //     // }

  //   //   if (kickoffLatestEndTime && latestSessionStartTime) {
  //   //     if (kickoffLatestEndTime > latestSessionStartTime) {
  //   //       window.scroll({
  //   //         // top: selectedOption === "flexRadioDefault2" ? 1900 : 1750,
  //   //         top: selectedOption === "flexRadioDefault2" 
  //   //     ? 1900 
  //   //     : 1750 + (addDaysCount === "2" ? 530 : addDaysCount === "3" ? 1050 : 0),
  //   //         behavior: "smooth",
  //   //       });
  //   //       return;
  //   //     }
  //   //   }

  //   }
    
  //   setIsLoading(true);
  //   if (dataSubmit) {
  //     console.log('dataSubmit',dataSubmit)
  //     dataSubmit.is_draft = isDraft
  //     dispatch(
  //       postWorkshop({
  //         module: "postWorkshopSubmit",
  //         postData: {
  //           dataSubmit,
  //         },
  //       })
  //     );
  //   }
  // };  

  const handleSubmitForm = (payload) => {
    console.log("payload", payload)
    setIsLoading(true);
    dispatch(
      postWorkshop({
        module: "postWorkshopSubmit",
        postData: {
          dataSubmit: payload,
        },
      })
    );
  }
  

  return (
    <>
      <Page>
        <Loader start={isLoading} />
        <GroupWorkshopForm 
          pageLine="Create Masterclass"
          sessionId={''}
          sessionOnlyUpdate={false}
          handleSubmitForm={handleSubmitForm} 
          confirmModal={confirmModal} 
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg} 
          // setShowModalMsg={setShowModalMsg}
          // isLaoding={isLoading} 
          setIsLoading={setIsLoading}
          error={error}
          setError={setError}
          showLimitPopup={showLimitPopup} 
          setShowLimitPopup={setShowLimitPopup}
          btnName="publish"
          saveBtn={true}
          setIsDraft={setIsDraft}
        />
      </Page>
    </>
  );
};

export default GroupWorkshop;
